export { default } from './HTMLElementType';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/HTMLElementType/index.js
// module id = 162
// module chunks = 22